import { postRequest } from "../services/apiHelpers";

export const postLogin = async (payload) => {
  try {
    const res = await postRequest({ url: "/users/login", payload: payload });
    return res;
  } catch (e) {
    throw e;
  }
};

export const postLogout = async () => {
  try {
    const res = await postRequest({ url: "/users/logout" });
    return res;
  } catch (e) {
    throw e;
  }
};

export const postForgotPassword = async (payload) => {
  try {
    const res = await postRequest({
      url: "/users/forgot-password",
      payload: payload,
    });
    return res;
  } catch (e) {
    throw e;
  }
};

export const postResetPassword = async (payload) => {
  try {
    const res = await postRequest({
      url: "/users/reset-password",
      payload: payload,
    });
    return res;
  } catch (e) {
    throw e;
  }
};

export const postChangePassword = async (payload) => {
  try {
    const res = await postRequest({
      url: "/users/change-password",
      payload: payload,
    });
    return res;
  } catch (e) {
    throw e;
  }
};
